<template>
  <div>
    <!-- <el-button type="primary" icon="el-icon-plus"  circle @click="addGoods" v-if="!readonly" style="float:right;margin:10px 15px 10px 0;"></el-button> -->
    <el-table ref="list" border :data="tableData" style="width: 100%" @row-click="rowClick" show-summary :summary-method="getSummaries">
      <insert-row @on-insert="onInsert" />
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="GoodsCode" label="条码">
        <template slot-scope="{ row }">
          <span>{{ row.GoodsCode }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="GoodsName" label="商品名称" /> -->
      <el-table-column label="商品名称" min-width="150px" prop="GoodsName">
        <template slot-scope="{ row }">
          <account-select
            v-if="!readonly"
            v-model="row.GoodsName"
            :source="DAccount"
            @select="onSelect($event, row)"
            :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex"
            :listTotal="listTotal"
            @currentPage="currentPage($event, row)"
            @click.native="resetFun"
            @inputText="inputText($event, row)"
            :pageType="true"
          />
          <!-- <select-input
            v-if="!readonly"
            placeholder="请选择商品"
            :label="row.GoodsName"
            v-model="row.GoodsId"
            @click="openGoods(row)"
          /> -->
          <span v-else>{{ row.GoodsName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="Quantity1" label="辅单位数量1" width="90px">
        <template slot-scope="{ row }">
          <el-input
            size="mini"
            v-model="row.Quantity1"
            type="number"
            @input="changeNum(row)"
            @blur="onBlur(row, 'Quantity1')"
            @focus="onFocus(row, 'Quantity1')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Quantity1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId1" label="辅单位1">
        <template slot-scope="{ row }">
          <el-select
            v-if="row.Units && row.Units.length"
            size="mini"
            v-model="row.UnitId1"
            :placeholder="readonly ? '' : '请选择'"
            :disabled="readonly"
            @change="unitChange(row, '1')"
          >
            <el-option v-for="(item, index) in row.Units" :key="index" :label="item.UnitName" :value="item.UnitId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="Offer" label="报价">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Offer"
            type="number"
            @blur="onBlur(row, 'Offer')"
            @focus="onFocus(row, 'Offer')"
            @input="rateChange(row)"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ $commonJs.getThousandNum(row.Offer) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">
          {{ $commonJs.getThousandNum(row.Price) }}
        </template>
      </el-table-column>
      <el-table-column prop="NoTaxAmount" label="不含税金额" width="90">
        <template slot-scope="{ row }">
          {{ $commonJs.getThousandNum(row.NoTaxAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注" width="150px">
        <template slot-scope="{ row }">
          <el-input v-model="row.Remark" @input="row.OrderGoodsId > 0 ? (row.T = 1) : (row.T = 0)" v-if="!readonly"></el-input>
          <span v-else>{{ row.Remark }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="主单位数量" width="90px">
        <template slot-scope="{ row }">
          <span>{{ row.Quantity }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId" label="主单位">
        <template slot-scope="{ row }">
          <el-select v-if="row.Units && row.Units.length" size="mini" v-model="row.UnitId" :placeholder="readonly ? '' : '请选择'" :disabled="true">
            <el-option v-for="(item, index) in row.Units" :key="index" :label="item.UnitName" :value="item.UnitId"></el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column prop="Quantity2" label="辅单位数量2" width="90px">
        <template slot-scope="{ row }">
          <span>{{ row.Quantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId2" label="辅单位2">
        <template slot-scope="{ row }">
          <el-select
            v-if="row.Units && row.Units.length"
            size="mini"
            v-model="row.UnitId2"
            :placeholder="readonly ? '' : '请选择'"
            :disabled="readonly"
            @change="unitChange(row, '2')"
          >
            <el-option v-for="(item, index) in row.Units" :key="index" :label="item.UnitName" :value="item.UnitId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="ExistQuantity" label="现存量" />
      <!-- <el-table-column prop="AvailableQuantity" label="可用量 " /> -->

      <el-table-column prop="Discount" label="折扣%">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Discount"
            type="number"
            @blur="onBlur(row, 'Discount')"
            @focus="onFocus(row, 'Discount')"
            @input="disChange(row)"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Discount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="TaxRate" label="税率/%">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.TaxRate"
            type="number"
            @blur="onBlur(row, 'TaxRate')"
            @focus="onFocus(row, 'TaxRate')"
            @input="rateChange(row)"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.TaxRate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="TaxAmount" label="税额">
        <template slot-scope="{ row }">
          {{ $commonJs.getThousandNum(row.TaxAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="Amount" label="含税金额">
        <template slot-scope="{ row }">
          {{ $commonJs.getThousandNum(row.Amount) }}
        </template>
      </el-table-column>

      <!-- <el-table-column prop="PromotionId" label="参与活动" width="100px">
        <template slot-scope="{ row }">
          <el-select
            v-model="row.PromotionId"
            placeholder="请选择"
            clearable
            v-if="!readonly"
            @input="changeNum(row)"
          >
            <el-option label="团购" :value="0"></el-option>
            <el-option label="秒杀" :value="1"></el-option>
            <el-option label="折扣" :value="2"></el-option>
          </el-select>
          <span
            v-else
          >{{row.PromotionId==0?'团购':row.PromotionId==1?"秒杀":row.PromotionId==2?"折扣%":""}}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="ReferenceCost" label="预估成本单价" width="110px">
        <template slot-scope="{ row }">
          {{ $commonJs.getThousandNum(row.ReferenceCost) }}
        </template>
      </el-table-column>
      <el-table-column prop="GrossProfit" label="毛利">
        <template slot-scope="{ row }">
          {{ $commonJs.getThousandNum(row.GrossProfit) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="130px" v-if="!readonly">
        <template slot-scope="{ row, $index }">
          <!-- <el-link icon="el-icon-plus"  style="margin-right:10px;" @click="interpolate(row,$index)" :underline="false">插行</el-link> -->
          <el-link icon="el-icon-copy-document" style="margin-right: 10px" @click.stop="copy(row, $index)" :underline="false">复制</el-link>
          <el-link icon="el-icon-delete" @click.stop="del(row, $index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
    <goods-info-dialog ref="goodsInfoDialog" in-dialog selectable @select="setGoodsInfo" />
  </div>
</template>
<script>
import goodsDialog from '@/components/sales/business/listDialog'
import accountSelect from '@/components/sales/business/select'
import goodsInfoDialog from '@/components/basicinfo/goods/archives/listDialog'
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false
    },
    showTax: {
      type: Number,
      default: 0
    }
  },
  components: {
    goodsDialog,
    accountSelect,
    goodsInfoDialog
  },
  data() {
    return {
      listTotal: 0,
      pageParams: {
        pageSize: 15, //分页大小
        pageIndex: 1
      },
      tableData: [
        {
          T: 0,
          OrderGoodsId: 0,
          OrderId: 0,
          BarCode: '',
          GoodsName: '',
          GoodsId: '',
          Model: '',
          UnitId: 0,
          UnitName: '',
          Quantity: 0,
          BatchNo: '',
          Offer: 0,
          Discount: 100,
          Price: 0,
          ExistQuantity: 0,
          AvailableQuantity: 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionId: 0,
          PromotionId: 0,
          ReferenceCost: 0,
          GrossProfit: 0,
          Remark: '',
          Thumbnail: '',
          OutQuantity: 0,
          AddTime: ''
        }
      ],
      current: null,
      tableDel: [],
      multi: require('@/api/goods/multiUnit').default,
      sApi: require('@/api/goods/goods').default,
      api: require('@/api/sale/stInDoc').default,
      saleApi: require('@/api/sale/sales').default,
      account_api: require('@/api/goods/goods').default,
      PriAdjustGoodsList: [],
      DAccount: [],
      initDAccount: [],
      initTotal: 0
    }
  },
  mounted() {
    this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 15 }).then(res => {
      if (res.Code == 0) (this.DAccount = res.Data), (this.initDAccount = res.Data), (this.initTotal = res.Count)
    })
  },
  methods: {
    onInsert(e) {
      let { type, index } = e

      this.interpolate(null, index, type)
    },
    unitChange(row, name) {
      console.log(row)
      row.Units.forEach(e => {
        if (e.UnitId == row['UnitId' + name]) {
          row['Rate' + name] = e.Rate
        }
      })
      this.count(row)
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage(val, row) {
      let GoodsName = row.GoodsName
      this.pageParams.pageIndex = val
      this.account_api.list({ Status: 1, pageIndex: val, pageSize: 15, GoodsName }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    inputText(text, row) {
      if (text == row.GoodsName) {
        //console.log("相同", text);
        return
      }
      row.GoodsName = text
      this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 15, GoodsName: text }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    openGoods(row) {
      this.current = row
      this.$refs.goodsInfoDialog.open().then(that => {
        that.getTree()
        that.getData()
      })
    },
    setGoodsInfo(e) {
      this.current.GoodsId = e.GoodsId
      this.current.GoodsName = e.GoodsName
      this.current.T = this.current.T == 0 ? 0 : 1
      this.current.OrderGoodsId = this.current.OrderGoodsId || 0
      this.current.OrderId = this.info.OrderId || 0
      this.current.BarCode = e.BarCode
      this.current.GoodsName = e.GoodsName
      this.current.GoodsId = e.GoodsId
      this.current.Model = e.Model || ''
      this.current.UnitId = e.UnitId || 0
      this.current.UnitName = e.MainUnitName || ''
      this.current.Quantity = 0
      this.current.BatchNo = e.BatchNo || ''
      this.current.Offer = e.WholesalePrice || 0
      this.current.Discount = 100
      this.current.Price = e.WholesalePrice || 0
      this.current.ExistQuantity = e.ExistQuantity || 0
      this.current.AvailableQuantity = e.AvailableQuantity || 0
      this.current.TaxRate = 0
      this.current.TaxAmount = 0
      this.current.Amount = 0
      this.current.NoTaxAmount = 0
      this.current.PromotionId = 0
      this.current.PromotionId = 0
      this.current.ReferenceCost = e.ReferenceCost || 0
      this.current.GrossProfit = 0
      this.current.Remark = e.Remark || ''
      this.current.Thumbnail = ''
      this.current.OutQuantity = 0
      this.current.AddTime = this.info.DocDate || today
    },
    validateCounts(row, index, e, name) {
      e.target.blur() // 或者this.$refs[row.id].blur()
      this.$refs[Object.keys(this.$refs)[index + 1] + name].focus()
    },
    // 非分页 千位符+保留后两位
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const fieldNames = columns.map(col => col.property)
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity1', 'NoTaxAmount', 'Quantity2', 'Quantity', 'CostPrice', 'TaxAmount', 'Amount', 'Offer'].includes(field)) {
          const values = data.map(item => Number(item[field]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            // 数量字段，保留4位小数
            if (['Quantity', 'Quantity1', 'Quantity2'].includes(field)) {
              sums[index] = Math.round(sums[index] * Math.pow(10, 4)) / Math.pow(10, 4)
            } else {
              sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
          } else {
            sums[index] = '/'
          }
        } else {
          sums[index] = ''
        }
      })
      sums[0] = '合计'
      return sums
    },
    rowClick(row) {
      if (!this.readonly) {
        var index = this.$refs.list.data.indexOf(row)
        if (index + 1 == this.$refs.list.data.length) {
          //
          this.addGoods()
        }
      }
    },
    onSelect(e, row) {
      if (!this.info.CustomerId) {
        this.$message.error('请选择客户')
        return
      }

      // 先获取单位数据
      this.multi.list({ GoodsId: e.GoodsId }).then(res => {
        // 更新基本数据
        row.T = row.T == 0 ? 0 : 1
        row.OrderGoodsId = row.OrderGoodsId || 0
        row.OrderId = this.info.OrderId || 0
        row.BarCode = e.BarCode
        row.GoodsCode = e.BarCode
        row.GoodsName = e.GoodsName
        row.GoodsId = e.GoodsId
        row.Model = e.Model || ''
        row.UnitId = e.UnitId || 0
        row.UnitName = e.MainUnitName || ''
        row.Quantity = 0
        row.Quantity1 = 0
        row.Quantity2 = 0
        row.BatchNo = e.BatchNo || ''
        row.Offer = e.WholesalePrice || 0
        row.Discount = 100
        row.Price = e.WholesalePrice || 0
        row.ExistQuantity = e.ExistQuantity || 0
        row.AvailableQuantity = e.AvailableQuantity || 0
        row.TaxRate = 0
        row.TaxAmount = 0
        row.Amount = 0
        row.NoTaxAmount = 0
        row.PromotionId = 0
        row.ReferenceCost = e.ReferenceCost || 0
        row.GrossProfit = 0
        row.Remark = e.Remark || ''
        row.Thumbnail = ''
        row.OutQuantity = 0
        row.AddTime = this.info.DocDate || today

        // 设置单位数据
        row.Units = res.Data
        res.Data.forEach(e => {
          if (e.IsMain) {
            row.UnitId = e.UnitId
            row.UnitId1 = e.UnitId
            row.Rate1 = e.Rate
          }
          if (row.UnitId2 == e.UnitId) {
            row.Rate2 = e.Rate
          }
        })

        // 强制更新视图
        this.$set(row, 'Units', row.Units)
        this.$set(row, 'UnitId', row.UnitId)
        this.$set(row, 'UnitId1', row.UnitId1)
        this.$set(row, 'UnitId2', row.UnitId2)

        // 获取客户报价
        this.sApi.getGoodsOffer({ GoodsId: e.GoodsId, TradeUnitId: this.info.CustomerId, DocType: 0 }).then(res => {
          row.Offer = res.Data
          row.Price = res.Data
        })
      })
    },
    getData() {
      // this.tableData = [];
      this.info.Goods.forEach(e => {
        if (e.UnitId == 0) {
          e.UnitId = null
        }
        if (e.UnitId1 == 0) {
          e.UnitId1 = null
        }
        if (e.UnitId2 == 0) {
          e.UnitId2 = null
        }
        e.T = null
        e.Units.forEach(v => {
          if (e.UnitId1 == v.UnitId) {
            e.Rate1 = v.Rate
          }
          if (e.UnitId2 == v.UnitId) {
            e.Rate2 = v.Rate
          }
        })
      })
      this.tableData = this.info.Goods
      // this.saleApi.getGoodsList(this.info.OrderId).then((res) => {
      //   this.tableData = res.Data;
      // });
    },
    del(row, index) {
      this.$confirm('确认删除该行数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.T !== 0) {
          row.T = 2
          this.tableDel.push(row)
        }
        if (this.tableData.length == 1) {
          this.tableData.splice(index, 1)
          this.addGoods()
        } else {
          this.tableData.splice(index, 1)
        }
        this.subTable()
      })
    },
    interpolate(row, index, type = '') {
      let goods = {
        T: 0,
        OrderGoodsId: 0,
        OrderId: 0,
        BarCode: '',
        GoodsName: '',
        GoodsId: '',
        Model: '',
        UnitId: 0,
        UnitName: '',
        Quantity: 0,
        Quantity1: 0,
        Quantity2: 0,
        BatchNo: '',
        Offer: 0,
        Discount: 100,
        Price: 0,
        ExistQuantity: 0,
        AvailableQuantity: 0,
        TaxRate: 0,
        TaxAmount: 0,
        Amount: 0,
        NoTaxAmount: 0,
        PromotionId: 0,
        PromotionId: 0,
        ReferenceCost: 0,
        GrossProfit: 0,
        Remark: '',
        Thumbnail: '',
        OutQuantity: 0,
        AddTime: '',
        UnitId: '',
        UnitId1: '',
        UnitId2: ''
      }
      if (type == 'down') {
        index = index + 1
      }
      this.tableData.splice(index, 0, goods)
      let copy = JSON.parse(JSON.stringify(this.tableData))
      this.tableData = []
      this.$nextTick(() => {
        copy.forEach((x, index) => {
          if (x.OrderGoodsId > 0) {
            x.T = 1
          }
          x.Sn = index + 1
        })
        this.tableData = copy
      })
      console.log('this.tableData', this.tableData)
    },
    copy(row, index) {
      this.tableData.splice(index, 0, {
        ...row
      })
      this.tableData[index].OrderGoodsId = 0
      this.tableData[index].T = 0
      this.tableData.forEach((x, index) => {
        if (x.OrderGoodsId > 0) {
          x.T = 1
        }
        x.Sn = index + 1
      })
      this.subTable()
    },
    addGoods() {
      // let ids = this.PriAdjustGoodsList.map((x) => x.GoodsId);
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getData({ Status: 1, NotIds: ids });
      // });
      let goods = {
        T: 0,
        OrderGoodsId: 0,
        OrderId: 0,
        BarCode: '',
        GoodsName: '',
        GoodsId: '',
        Model: '',
        UnitId: 0,
        UnitName: '',
        Quantity: 0,
        Quantity1: 0,
        Quantity2: 0,
        BatchNo: '',
        Offer: 0,
        Discount: 100,
        Price: 0,
        ExistQuantity: 0,
        AvailableQuantity: 0,
        TaxRate: 0,
        TaxAmount: 0,
        Amount: 0,
        NoTaxAmount: 0,
        PromotionId: 0,
        PromotionId: 0,
        ReferenceCost: 0,
        GrossProfit: 0,
        Remark: '',
        Thumbnail: '',
        OutQuantity: 0,
        AddTime: '',
        UnitId: '',
        UnitId1: '',
        UnitId2: ''
      }
      this.tableData.push(goods)
      this.tableData.forEach((x, index) => {
        x.Sn = index + 1
      })
    },
    setGoods(e, row) {
      console.log('./', this.info)
      if (this.info.CustomerId == 0) {
        this.$message.error('请选择客户')
        return
      }
      let date = new Date()
      let today = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      this.sApi
        //.getGoodsPrice({ GoodsIds: [e.GoodsId], AdjustDate: this.info.DocDate })
        .getGoodsOffer({ GoodsId: e.GoodsId, TradeUnitId: this.info.CustomerId, DocType: 0 })
        .then(res => {
          let goods = {
            T: 0,
            OrderGoodsId: 0,
            OrderId: this.info.OrderId || 0,
            BarCode: e.BarCode,
            GoodsName: e.GoodsName,
            GoodsId: e.GoodsId,
            Model: e.Model || '',
            UnitId: e.UnitId || 0,
            UnitName: e.MainUnitName || '',
            Quantity: 0,
            BatchNo: e.BatchNo || '',
            Offer: e.WholesalePrice || 0,
            Discount: 100,
            Price: e.WholesalePrice || 0,
            ExistQuantity: e.ExistQuantity || 0,
            AvailableQuantity: e.AvailableQuantity || 0,
            TaxRate: 0,
            TaxAmount: 0,
            Amount: 0,
            NoTaxAmount: 0,
            PromotionId: 0,
            PromotionId: 0,
            ReferenceCost: e.ReferenceCost || 0,
            GrossProfit: 0,
            Remark: e.Remark || '',
            Thumbnail: '',
            OutQuantity: 0,
            AddTime: this.info.DocDate || today
          }
          if (res.Data != null) {
            goods.Offer = res.Data.VirtualPrice
          }
          this.tableData.push(goods)
        })
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null
    },
    changeNum(row) {
      // row.Quantity = Math.floor(row.Quantity)

      this.count(row)
    },
    rateChange(row) {
      this.count(row)
    },
    disChange(row) {
      this.count(row)
    },
    count(row) {
      // row.Offer=Number(row.Offer||0)
      // row.Quantity1=Number(row.Quantity1||0);
      // row.Rate1=Number(row.Rate1||1);
      // row.Rate2=Number(row.Rate2||1);
      let price = row.Price ? Number(row.Price) : 0
      let dis = row.Discount > 0 ? Number(row.Discount) : 100
      let qua = row.Quantity1 ? Number(row.Quantity1) : 0
      let rate = row.TaxRate ? Number(row.TaxRate) : 0
      let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0
      if (row.T !== 0) row.T = 1
      row.Price = dis ? (row.Offer * (dis / 100) * (1 + rate / 100)).toFixed(2) : (row.Offer * (1 + rate / 100)).toFixed(2)
      row.Amount = ((row.Price * qua * 100) / 100).toFixed(2)
      row.NoTaxAmount = (row.Offer * (dis / 100) * row.Quantity1).toFixed(2)
      row.TaxAmount = ((qua * (((dis ? row.Offer * (dis / 100) : row.Offer) * rate) / 100) * 100) / 100).toFixed(2) || 0
      row.GrossProfit = (row.Amount - qua * ref).toFixed(2)
      row.Quantity = (1 / Number(row.Rate1 || 1)) * qua

      if (row.UnitId2 == row.UnitId) {
        row.Quantity2 = row.Quantity
      } else {
        console.log(row.Rate2, row.Quantity)
        if (!row.Rate2) {
          row.Quantity2 = 0
        } else {
          row.Quantity2 = row.Rate2 * row.Quantity
        }
      }
      this.subTable()
    },
    subTable() {
      this.$emit('getList', this.tableData.concat(this.tableDel))
    }
  }
}
</script>

<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
